var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2MHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_headgear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headgear_x5F_2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M495.3,194.9c3.3-4.2,16.3-18,10.8-22.2c-80.2-16.1-163.1-19.4-244.4-7.2c-10.7,1.6-21.4,3.4-32.1,5.5 c-6.1,1.3-12.1,2.8-18,4.4c-1.4,4.1,4,11.2,5.9,13.9c3.6,5,7.4,10.2,11.5,14.7c4.6,5,10.4,9.3,15.9,9.3 c74-19.9,152.7-19,228.3-3.5C483,209.2,489.3,202.6,495.3,194.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M252.6,166.8c-7.7,1.2-15.4,2.6-23,4.1c-6.1,1.3-12.1,2.8-18,4.4c-1.4,4.1,4,11.2,5.9,13.9 c3.6,5,7.4,10.2,11.5,14.7c4.6,5,10.4,9.3,15.9,9.3c26.9-7.2,54.3-11.7,82.1-13.7C299.8,194.7,272,186.8,252.6,166.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M257.8,80.4c-8.1,25.3-14,60.4-14.7,88c6.2-1.1,12.4-2.1,18.6-3c70.9-10.6,142.9-9.5,213.3,1.7 c-2.3-32.4-7.1-64.4-16.5-94.4C405.6,56,318.6,50.2,257.8,80.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M257.8,80.4c-6.6,20.4-11.6,47.2-13.7,71.3c9.6-2.3,19.4-4.3,29.4-6c0.1-24.9,3.6-53.9,8.7-75.1 C273.7,73.3,265.6,76.5,257.8,80.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M244.1,151.7c-0.5,5.8-0.8,11.4-1,16.8c6.2-1.1,12.4-2.1,18.6-3c70.9-10.6,142.9-9.5,213.3,1.7 c-0.4-5.1-0.8-10.2-1.3-15.3C404,133.8,316.6,134.1,244.1,151.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M433.8,143.7c-6.8-1-13.7-1.9-20.7-2.6l0.8,18.9c7,0.5,13.9,1.1,20.9,1.8L433.8,143.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2MHair5);
export default __webpack_public_path__ + "static/media/m-hat2_m-hair5.e59806ab037b1ed1b7b4e6c68c33c21c.svg";
export { ForwardRef as ReactComponent };